var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex center"},[_c(require('@/assets/icons/menu.svg'),{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }